import { Box, Button, Typography } from '@mui/material';
import { FC } from 'react';
import { t } from 'i18next';
import { Info } from '@mui/icons-material';

import { CustomModal, FileUploader } from '@components';
import { theme } from '@store';
import { useImportPracticeModal } from '@views/pages/Admin/Practice/hooks';
import { Select } from 'ui';

interface ImportBuildingModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

export const ImportPracticeModal: FC<ImportBuildingModalProps> = ({
  isOpen,
  handleClose,
}) => {
  const {
    partnerOptions,
    partnerId,
    handleChangePartnerId,
    handleDownloadCSVTemplate,
    isTemplateBtnDisabled,
    handleImportCsvFile,
    handleChangeFile,
    importError,
    file,
    handleCloseAction,
  } = useImportPracticeModal(handleClose);

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={handleCloseAction}
      title={t('adminPanel.practices.importModal.title')}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Select
          name='partner'
          size='medium'
          label={t('adminPanel.practices.importModal.partner')}
          required
          value={partnerId}
          onChange={handleChangePartnerId}
          options={partnerOptions}
        />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant='body2' sx={{ color: 'text.disabled' }}>
            {t('adminPanel.practices.importModal.templateText')}
          </Typography>
          <Button
            variant='outlined'
            onClick={handleDownloadCSVTemplate}
            disabled={isTemplateBtnDisabled}
            sx={{ width: 210 }}
          >
            {t('adminPanel.practices.importModal.downloadButton')}
          </Button>
        </Box>
        {importError.length > 0 && file && (
          <Box
            sx={{
              p: 2,
              color: theme.palette.common.white,
              background: theme.palette.error.main,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Info />
              <Typography>
                {importError.length} formating errors found
              </Typography>
            </Box>
            <Box
              sx={{
                maxHeight: 100,
                overflowY: 'scroll',
              }}
            >
              {importError.map((item: string) => {
                return (
                  <Box key={item} sx={{ ml: 4 }}>
                    {item}
                  </Box>
                );
              })}
            </Box>
          </Box>
        )}

        <FileUploader setFile={handleChangeFile} file={file} />

        <Box
          sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, py: 3 }}
        >
          <Button variant='outlined' onClick={handleCloseAction}>
            {t('adminPanel.practices.importModal.cancel')}
          </Button>
          <Button
            variant='contained'
            onClick={handleImportCsvFile}
            sx={{ fontWeight: 'regular', fontSize: '1rem', color: 'white' }}
            color='secondary'
          >
            {t('adminPanel.practices.importModal.import')}
          </Button>
        </Box>
      </Box>
    </CustomModal>
  );
};
